import { useAppSelector } from "../../store/reducer";
import { createDateString } from "../../utils/date-utils";
import styles from "../../styles/oppgave-detaljer.module.scss";
import { useGetResources } from "../../hooks/useGetResources";

export const MottattDato = (): React.JSX.Element | null => {
  const oppgave = useAppSelector((state) => state.oppgaveDetaljer.oppgave);
  const resources = useGetResources();

  return (
    <div className={styles.mottattDato_seksjon}>
      <p className={styles.mottattDato}>
        {(resources?.motattDato_label || "") +
          " " +
          createDateString(oppgave?.MottattDato, "dd.MM.yyyy HH:mm")}
      </p>
    </div>
  );
};
